module.exports = __webpack_public_path__ + "img/bridgit.878aa021.svg";